module.exports = __webpack_public_path__ + "static/media/LK__Edit Content.63a67940.svg";